import classNames from 'classnames'
import * as React from 'react'

import NativeEvents from '../../../containers/NativeEvents'
import {_tc_es} from '../../../types/BS_types'

import styles from './PopupControl.css'

type Props = React.JSX.IntrinsicElements['span'] & {
  labelClassName?: string
  showPopupCommand?: (e: React.SyntheticEvent<HTMLSpanElement> | Event) => unknown
  hidePopupCommand?: (e: React.SyntheticEvent<HTMLSpanElement>) => unknown
  stopHidingPopupCommand?: (e: React.SyntheticEvent<HTMLSpanElement>) => unknown
  controlId?: string
  type?: string
  topRightButton?: boolean
  wrapperProps?: React.JSX.IntrinsicElements['span']
}

function PopupControl({
  children,
  className,
  labelClassName,
  showPopupCommand,
  hidePopupCommand,
  stopHidingPopupCommand,
  controlId,
  type,
  topRightButton,
  wrapperProps,
  ...restProps
}: Props) {
  const classes = classNames(
    styles.legacyPopupControl,
    'pc',
    className,
    type != null && `pc_${type}`,
    {
      pc_topRightButton: topRightButton,
    },
  )
  const labelClasses = classNames(styles.label, labelClassName, 'pc_label')
  const toggle = React.useMemo(() => {
    const handleToggleClick = (e: Event) => {
      if (_tc_es(e) && showPopupCommand) {
        showPopupCommand(e)
      }
    }

    const toggleClasses = classNames(styles.toggle, 'icon', 'icon16', 'toggle')
    return (
      <span className="pc__toggle-wrapper">
        <NativeEvents click={handleToggleClick}>
          {ref => (
            <button
              aria-label="Toggle popup"
              type="button"
              ref={ref}
              id={controlId}
              className={toggleClasses}
              onMouseOver={showPopupCommand}
              onFocus={showPopupCommand}
            />
          )}
        </NativeEvents>
      </span>
    )
  }, [controlId, showPopupCommand])
  return (
    <span
      {...restProps}
      {...wrapperProps}
      className={classes}
      onMouseOver={stopHidingPopupCommand}
      onFocus={stopHidingPopupCommand}
      onMouseOut={hidePopupCommand}
      onBlur={hidePopupCommand}
    >
      <span className={labelClasses}>{children}</span>
      {toggle}
    </span>
  )
}

export default React.memo(PopupControl)
